module.exports = __webpack_public_path__ + "assets/img/Type BS (23).9c0a581d.jpg";